export default "__VITE_ASSET__7be7e51d__"